import { Component, Inject, OnInit, Optional } from '@angular/core';
import { LayoutService } from '@app/core/services/layout.service';
import { UtilityService } from '@app/core/services/utility.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { P2UpdateProcedureItem, P2UpdateProcedureService, P2UpdateProcedureSettingsGet } from '@app/services/p2-update-procedure.service';

@Component({
    selector: 'tt-p2-update-procedures',
    templateUrl: './p2-update-procedures.component.html',
    styleUrls: ['./p2-update-procedures.component.css'],
    standalone: false,
})
export class P2UpdateProceduresComponent implements OnInit {
    public setting?: P2UpdateProcedureSettingsGet;

    public procedures: P2UpdateProcedureItem[] = [];

    public itemState = '';

    public selectedProcedureKeyno = '';

    public readonly tabletSize: MediaQueryList;

    private navigator?: TTViewNavigator;

    constructor(
        private procedureService: P2UpdateProcedureService,
        private utility: UtilityService,
        layout: LayoutService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) navigator?: TTViewNavigator,
    ) {
        this.tabletSize = layout.getMediaQueries().tablet;
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async loadProcedures(): Promise<void> {
        this.procedures = await this.procedureService.listProcedures();
        this.itemState = this.procedures.find((item) => !!item.item_state)?.item_state ?? '';
    }

    public async updateList(): Promise<void> {
        this.selectedProcedureKeyno = '';
        await this.loadProcedures();
    }

    public openProcedure(item: P2UpdateProcedureItem, event?: MouseEvent): void {
        const keyno = `${item.item_id}`;

        if (this.tabletSize.matches && this.itemState === 'p2updateprocedureedit') {
            this.selectedProcedureKeyno = keyno;
            return;
        }

        const target = {
            to: 'p2updateprocedureedit',
            parms: { p2_updateprocedure_keyno: keyno }
        };


        if (event && this.navigator && this.utility.isModifierKeyPressed(event)) {
            void this.navigator.newTab(target);
        } else {
            void this.navigator?.go(target);
        }
    }

    public createProcedure(event?: MouseEvent): void {
        if (this.tabletSize.matches && this.itemState === 'p2updateprocedureedit') {
            this.selectedProcedureKeyno = '0';
            return;
        }

        const target = {
            to: 'p2updateprocedureedit',
            parms: { p2_updateprocedure_keyno: '0' }
        };

        if (event && this.navigator && this.utility.isModifierKeyPressed(event)) {
            void this.navigator.newTab(target);
        } else {
            void this.navigator?.go(target);
        }
    }

    public ngOnInit(): void {
        void this.init();
    }

    private async init(): Promise<void> {
        const [setting] = await Promise.all([
            this.procedureService.getSettings(),
            this.loadProcedures(),
        ]);

        this.setting = { ...setting, searchtext: setting.searchtext ?? '' };
    }
}
